export class AppConstants {
  static readonly DEFAULT_APP_CONTEXT = "CARETEAM";
  static readonly ACCESS_TOKEN = "access_token";
  static readonly APP_LOGIN_ROUTE = "/authentication/login";
  static readonly APP_LOGIN_REGISTER = "/authentication/register";
  static readonly APP_RESET_PASSWORD = "/authentication/reset-password";
  static readonly PATIENT_CONSENTS = "/patient-consents";
}
